export let License;
(function (_License) {
  let Type = /*#__PURE__*/function (Type) {
    Type["FAVOUR"] = "favour";
    Type["FREE"] = "free";
    Type["PAID_AUTO"] = "paid_auto";
    Type["PAID_MANUAL"] = "paid_manual";
    Type["TRIAL"] = "trial";
    return Type;
  }({});
  _License.Type = Type;
  let Status = /*#__PURE__*/function (Status) {
    Status["TRIAL"] = "trial";
    Status["ACTIVE"] = "active";
    Status["PAST_DUE"] = "past_due";
    Status["PAYMENT_COLLECTION_PAUSED"] = "payment_collection_paused";
    Status["INACTIVE"] = "inactive";
    Status["INCOMPLETE"] = "incomplete";
    Status["CANCELED"] = "canceled";
    Status["UNPAID"] = "unpaid";
    return Status;
  }({});
  _License.Status = Status;
  let CompanyType = /*#__PURE__*/function (CompanyType) {
    CompanyType["BRAND"] = "brand";
    CompanyType["AGENCY"] = "agency";
    CompanyType["INTERNAL"] = "internal";
    return CompanyType;
  }({});
  _License.CompanyType = CompanyType;
})(License || (License = {}));